import { render, staticRenderFns } from "./listviewVisits.vue?vue&type=template&id=241c81d8&scoped=true"
import script from "./listviewVisits.vue?vue&type=script&lang=js"
export * from "./listviewVisits.vue?vue&type=script&lang=js"
import style0 from "./listviewVisits.vue?vue&type=style&index=0&id=241c81d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c81d8",
  null
  
)

export default component.exports